import { getUrlParam } from '../utils/UrlUtils'
import { getUserEmail } from './userEmail'
import { getUserSettings, updateUserSettings } from './UserSettingsProvider'
import { getTilesStore } from 'stores/RootStoreProvider'
import { readOutsideReaction } from 'utils/mobx/readOutsideReaction'

class EmailCaptureManager {
  /* More logic from EmailCapturePage could be extracted to here. For now just extract what we need for current features */
  shouldCaptureEmail() {
    if (getUrlParam('utm_source') === 'email' || getUrlParam('sms') === '1') {
      updateUserSettings({ passedEmailCaptureScreen: true })
      return false
    }

    return (
      readOutsideReaction(() => getTilesStore().tiles.length) === 0 &&
      !getUserEmail() &&
      !getUserSettings().passedEmailCaptureScreen
    )
  }

  passedAnyOnboarding() {
    return !this.shouldCaptureEmail()
  }
}

export const emailCaptureManager = new EmailCaptureManager()
